import React from 'react';
import { Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

const Container = styled('div')({
  width: '100px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative'
});

const Username = styled('h4')({
  padding: 0,
  margin: 0
});

export default function User({ user }) {

  if (!user) return null;

  const getAvatarUrl = (imagePath) => {
    if (!imagePath) return null;
    return imagePath.startsWith('http') ? imagePath : `${process.env.REACT_APP_API_URL_BASE}${imagePath}`;
  }

  return (
    <Container>
      {user.profile?.image ?
        <Avatar alt="user avatar" src={getAvatarUrl(user.profile.image)} /> :
        <Avatar alt="user avatar">{user.username ? user.username.slice(0, 2) : '??'}</Avatar>
      }
      <Username>{user.username}</Username>
    </Container>
  );
}

User.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string.isRequired,
    profile: PropTypes.shape({
      image: PropTypes.string
    }).isRequired
  }).isRequired
}